import React from 'react';
import * as actions from '../actions';
import componentServices from '../componentServices';
import valueFilters from '../valueFilters';

export default class ForgotPassword extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = { confirmation: false, email: '' };

		this.handleBackClick = this.handleBackClick.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleKeyPress = this.handleKeyPress.bind(this);
		this.handleResetClick = this.handleResetClick.bind(this);
	}

	handleChange (e) {
		const name = e.target.name;
		const newVal = e.type === 'change' ? e.target.value : valueFilters.clean(e.target.value);
		const patch = {};

		patch[name] = newVal;

		this.setState(patch);
	}
	handleBackClick (e) {
		e.preventDefault();
		componentServices.router.pushHistory('/login');
	}

	handleKeyPress (e) {
		if (e.which === 13) {
			e.preventDefault();
			this.requestReset();
		}
	}

	handleResetClick (e) {
		e.preventDefault();
		this.requestReset();
	}

	requestReset () {
		const { email } = this.state;

		actions.clearAlerts();

		if (!email) {
			actions.pushAlert({ type: 'error', message: 'Please enter an email address.' });
			return;
		}

		actions.requestPasswordReset({
			email: email
		});

		this.setState({
			confirmation: true
		});
	}

	render () {
		const { confirmation, email } = this.state;
		const resetStyle = (confirmation) ? { display: 'none' } : {};
		const confirmStyle = (confirmation) ? {} : { display: 'none' };

		return (
			<div>
				<section onKeyPress={this.handleKeyPress}>
					<div style={resetStyle}>
						<h1>Reset Password</h1>
						<p><input type="text" placeholder="Email Address" autoCapitalize="none" autoCorrect="off" name="email" value={ email } onChange={ this.handleChange } onBlur={ this.handleChange } /></p>
						<button onClick={this.handleResetClick}><span>Reset</span></button>
					</div>
					<div style={confirmStyle}>
						<h1>Instructions Sent</h1>
						<p>We've emailed you instructions to reset your password.</p>
						<button className="labelOnly" onClick={this.handleBackClick}><span>Back to Log In</span></button>
					</div>
				</section>
			</div>
		);
	}
}